import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
export function TopRibbon() {
  return <div className="bg-medical-red text-white py-2 px-6 relative z-[60]" role="complementary" data-id="element-73">
      <div className="max-w-7xl mx-auto flex justify-between items-center gap-4 text-[10px] md:text-xs font-body font-semibold" data-id="element-74">
        <div className="flex items-center gap-4 md:gap-8 opacity-90 overflow-x-auto no-scrollbar whitespace-nowrap" data-id="element-75">
          <span className="flex items-center gap-2" data-id="element-76">
            <Phone size={14} data-id="element-77" /> +1 (555) 000-0000
          </span>
          <span className="flex items-center gap-2" data-id="element-78">
            <Mail size={14} data-id="element-79" /> info@globalrestorative.com
          </span>
          <span className="hidden sm:flex items-center gap-2" data-id="element-80">
            <MapPin size={14} data-id="element-81" /> Telehealth Worldwide
          </span>
        </div>
        <div className="flex items-center gap-3 shrink-0" data-id="element-82">
          <span className="hidden lg:inline-block tracking-wide" data-id="element-83">
            Start your restorative wellness journey today.
          </span>
          <button className="bg-white text-medical-red px-4 py-1.5 rounded-full text-[10px] font-display font-bold uppercase tracking-widest hover:bg-medical-gray transition-colors shadow-sm" aria-label="Book your free consultation" data-id="element-84">
            FREE Consultation
          </button>
        </div>
      </div>
    </div>;
}